export default {
  type: 'my_review',
  name: 'My Review',
  save: {
    fields: [
      { field: 'personId', type: 'Int', required: true },
      { field: 'nameFirst', required: true },
      'nameMid',
      { field: 'nameLast', required: true },
      'nameSuf',
      { field: 'email', required: true },
      'phone',
      'affiliation',
      {
        field: 'isSmallBusiness',
        type: 'Boolean',
        required: true,
        default: false
      },
      'address1',
      'address2',
      'city',
      'state',
      'zipCode',
      'countryCode',
      'employmentTypeCode',
      'userTypeCode',
      'orcid',
      'citizenCountryCode'
    ],
    key: ['personId'],
    input: 'person',
    update: 'updatePerson'
  },
  load: {
    nodeId: 'person',
    key: 'personByPersonId'
  },
  form: {
    //tabs: true,
    print: false,
    tabLabel: 'My Information',
    schema: [
      [
        {
          name: 'nameFirst',
          label: 'Name',
          required: true,
          labelWidth: 4,
          width: 4,
          placeholder: 'First *'
        },
        {
          name: 'nameMid',
          placeholder: 'Middle',
          noLabel: true,
          width: 2
        },
        {
          name: 'nameLast',
          placeholder: 'Last *',
          required: true,
          noLabel: true,
          width: 4
        },
        {
          name: 'nameSuf',
          placeholder: 'Suffix',
          noLabel: true,
          width: 2
        }
      ],
      [
        {
          name: 'email',
          labelWidth: 2,
          type: 'email',
          required: true,
          width: 6
        },
        {
          name: 'phone',
          labelWidth: 2,
          width: 6
        }
      ],
      [
        {
          name: 'affiliation',
          width: 9,
          labelWidth: 2,
          type: 'link',
          search: {
            field: 'instName',
            lookup: 'allInstitutions',
            additionalFields: [
              {
                name: 'address1',
                type: 'hidden',
                copyTo: 'address1'
              },
              {
                name: 'address2',
                type: 'hidden',
                copyTo: 'address2'
              },
              {
                name: 'city',
                type: 'hidden',
                copyTo: 'city'
              },
              {
                name: 'state',
                type: 'hidden',
                copyTo: 'state'
              },
              {
                name: 'zipCode',
                type: 'hidden',
                copyTo: 'zipCode'
              },
              {
                name: 'countryCode',
                type: 'hidden',
                copyTo: 'countryCode'
              },
              {
                name: 'smallBusiness',
                type: 'hidden',
                copyTo: 'isSmallBusiness'
              }
            ]
          }
        },
        {
          name: 'isSmallBusiness',
          label: 'Small Business',
          type: 'checkbox',
          width: 3,
          labelWidth: 9
        }
      ],
      [
        {
          name: 'address1',
          label: 'Address 1',
          labelWidth: 4,
          width: 6
        },
        {
          name: 'address2',
          label: 'Address 2',
          labelWidth: 4,
          width: 6
        }
      ],
      [
        {
          name: 'city',
          labelWidth: 2,
          width: 6
        },
        {
          name: 'state',
          labelWidth: 6,
          width: 3
        },
        {
          name: 'zipCode',
          label: 'Zip',
          labelWidth: 2,
          width: 3
        }
      ],
      {
        name: 'countryCode',
        label: 'Country',
        labelWidth: 1,
        type: 'select',
        options: {
          lookup: 'allCountries',
          value: 'countryCode',
          text: 'countryName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'CountriesOrderBy',
              default: 'COUNTRY_NAME_ASC'
            }
          ]
        }
      },
      {
        name: 'citizenCountryCode',
        label: 'Citizenship Country',
        labelWidth: 2,
        type: 'select',
        options: {
          lookup: 'allCountries',
          value: 'countryCode',
          text: 'countryName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'CountriesOrderBy',
              default: 'COUNTRY_NAME_ASC'
            }
          ]
        },
        hideIf: {
          field: 'personId',
          value: null
        }
      },
      [
        {
          name: 'employmentTypeCode',
          label: 'Employment Type',
          type: 'select',
          width: 6,
          labelWidth: 4,
          options: {
            lookup: 'allEmploymentTypes',
            value: 'employmentTypeCode',
            text: 'employmentTypeDesc'
          }
        },
        {
          name: 'userTypeCode',
          label: 'User Type',
          type: 'select',
          width: 6,
          labelWidth: 4,
          options: {
            lookup: 'allUserTypes',
            value: 'userTypeCode',
            text: 'userTypeDesc'
          }
        }
      ],
      {
        name: 'orcid',
        label: 'ORCID',
        labelWidth: 2
      }
    ]
  },
  joinTables: [
    {
      label: 'My Roles',
      message: 'Please email accounts@arm.gov to request any changes',
      lookup: 'allRolePeople',
      join: 'roleByRoleName',
      fields: [
        {
          field: 'roleName',
          name: 'roleName',
          required: true
        },
        'roleTitle',
        {
          field: 'roleName',
          alias: 'recordId',
          show: false
        }
      ]
    },
    {
      label: 'My Groups',
      message: 'Please email accounts@arm.gov to request any changes',
      lookup: 'allGroupPeople',
      join: 'groupByGroupId',
      fields: [
        {
          field: 'groupId',
          alias: 'recordId',
          show: false
        },
        {
          field: 'groupId',
          type: 'Int',
          required: true,
          show: false
        },
        'groupName',
        'groupDescription'
      ]
    },
    {
      id: 'myEmailLists'
    },
    {
      id: 'groupOwnerActive',
      tab: true,
      reviewItem: 'group',
      label: 'Groups (Owner)',
      lookup: 'allGroupsOwners',
      fields: [
        {
          field: 'groupId',
          variable: 'groupId',
          required: true
        },
        'groupName',
        'groupDescription',
        { field: 'numMembers', alias: 'members' },
        { field: 'numRoles', alias: 'roles' },
        {
          field: 'lastReviewed',
          label: 'Last Reviewed*',
          headerTitle: 'Asterisk indicates last reviewed by another person'
        }
      ],
      formType: 'my_review_group',
      reviewTitle: 'Review Group',
      submittedTitle: 'Group Change Request Submitted',
      submitSubject: 'Group [${groupName}] Update Request'
    },
    {
      id: 'emailOwnerActive',
      tab: true,
      reviewItem: 'email_list',
      label: 'Active Email Lists (Owner)',
      lookup: 'allEmailListOwners',
      conditions: {
        active: { type: 'Boolean', required: true, default: true }
      },
      fields: [
        {
          field: 'emailList',
          variable: 'emailList',
          required: true
        },
        { field: 'topicsList', alias: 'description' },
        {
          field: 'statusList',
          alias: 'status',
          type: 'select',
          options: [
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ]
        },
        { field: 'servicenow', label: 'ServiceNow', type: 'boolean' },
        { field: 'numMembers', alias: 'subscribers' },
        { field: 'numGroups', alias: 'groups' },
        {
          field: 'lastReviewed',
          label: 'Last Reviewed*',
          headerTitle: 'Asterisk indicates last reviewed by another person'
        }
      ],
      formType: 'my_review_email',
      reviewTitle: 'Review Email List',
      submittedTitle: 'Email List Change Request Submitted',
      submitSubject: '${emailList} Email List Update Request'
    },
    {
      id: 'emailOwnerInactive',
      tab: true,
      reviewItem: 'email_list',
      label: 'Inactive Email Lists (Owner)',
      lookup: 'allEmailListOwners',
      conditions: {
        active: { type: 'Boolean', required: true, default: false }
      },
      fields: [
        {
          field: 'emailList',
          variable: 'emailList',
          required: true
        },
        { field: 'topicsList', alias: 'description' },
        {
          field: 'statusList',
          alias: 'status',
          type: 'select',
          options: [
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ]
        },
        { field: 'servicenow', label: 'ServiceNow', type: 'boolean' },
        { field: 'numMembers', alias: 'subscribers' },
        { field: 'numGroups', alias: 'groups' },
        {
          field: 'lastReviewed',
          label: 'Last Reviewed*',
          headerTitle: 'Asterisk indicates last reviewed by another person'
        }
      ],
      formType: 'my_review_email',
      reviewTitle: 'Review Email List',
      submittedTitle: 'Email List Change Request Submitted',
      submitSubject: '${emailList} Email List Update Request'
    },
    {
      id: 'newArmStaff',
      tab: true,
      label: 'ARM Staff Updates'
    }
  ]
}
